<!--
  冻结的旧服务端兼容页面：用于 Level 0 或尚未确认服务端能力的兼容分支。
  对齐 APP 冻结边界：除旧接口契约变化、兼容性缺陷、严重安全问题或阻断性缺陷外，
  不调整本页布局、交互和请求逻辑；不得同步新版搜索、筛选、候选分页等功能。
  新版功能只在 modern-home-change-scene.vue 中维护，不得改用新版接口或通过请求失败探测能力。
  必要修复保留旧接口及参数语义，并回归旧服务加载、选择/控制、保存和返回链路。
  本页依赖共享组件及公共样式；修改这些依赖时也需检查旧服务兼容分支。
-->
<template>
  <section class="candidate-page">
    <header class="candidate-heading">
      <button class="control-link" :disabled="saving" @click="$router.back()">返回</button>
      <h2>常用场景配置</h2>
      <button class="control-link candidate-complete" :disabled="!ready || loading || saving" @click="configReturnBtnHandle">完成</button>
    </header>
    <div class="candidate-content">
      <scene-view :sceneList="serveSceneList" viewType="configScene" />
      <p v-if="loading" class="control-empty">正在加载…</p>
      <p v-else-if="!ready" class="control-empty">加载失败，请重试 <button class="control-link" @click="loadCandidates">重试</button></p>
      <p v-else-if="!serveSceneList.length" class="control-empty">暂无可配置的场景</p>
    </div>
  </section>
</template>
<script>
import SceneView from './scene-view/scene-view'

// Legacy servers use full-list APIs; never probe modern pagination endpoints.
export default {
  name: 'LegacyHomeChangeScene',
  components: { SceneView },
  data() {
    return { serveSceneList: [], loading: false, ready: false, saving: false }
  },
  mounted() { this.loadCandidates() },
  methods: {
    loadCandidates() {
      if (this.loading || this.saving) return
      this.loading = true
      this.ready = false
      return this.$request({
        method: 'post', url: '/home/findAllSceneByUserId',
        data: { token: this.$store.state.token, regionId: '', followState: '' }
      }).then(res => {
        if (!res.data || res.data.code != 0 || !Array.isArray(res.data.data))
          throw new Error((res.data && res.data.message) || '加载失败，请重试')
        this.serveSceneList = res.data.data.map(item => ({
          ...item, followState: Number(item.followState || 0)
        }))
        this.ready = true
      }).catch(error => {
        this.$showTipsToast(3, (error && error.message) || '加载失败，请重试', true, 3000)
      }).finally(() => { this.loading = false })
    },
    configReturnBtnHandle() {
      if (!this.ready || this.loading || this.saving) return
      const selected = this.serveSceneList.filter(item => Number(item.followState) === 1)
        .slice().sort((a, b) => Number(a.followOrder || 0) - Number(b.followOrder || 0))
      this.saving = true
      return this.$request({
        method: 'post', url: '/userScene/saveFollowStateScene',
        data: { token: this.$store.state.token, sceneList: selected.map(item => item.sceneId) }
      }).then(res => {
        if (!res.data || res.data.code != 0)
          throw new Error((res.data && res.data.message) || '保存失败，请重试')
        this.$router.replace('/controlpage/home')
      }).catch(error => {
        this.$showTipsToast(3, (error && error.message) || '保存失败，请重试', true, 3000)
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.candidate-page { height: 100%; display: flex; flex-direction: column; max-width: 1200px; margin: auto; }
.candidate-heading { flex: none; display: flex; align-items: center; justify-content: space-between; padding: 12px; gap: 10px; }
.candidate-heading h2 { font-size: 18px; color: #fff; }
.candidate-content { overflow: auto; min-height: 0; flex: 1; padding: 12px 5px 24px; }
</style>
